/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import HospitalsHospital from './HospitalsHospital';

/**
 * The HospitalsBody model module.
 * @module model/HospitalsBody
 * @version v0.3
 */
export default class HospitalsBody {
  /**
   * Constructs a new <code>HospitalsBody</code>.
   * @alias module:model/HospitalsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>HospitalsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/HospitalsBody} obj Optional instance to populate.
   * @return {module:model/HospitalsBody} The populated <code>HospitalsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new HospitalsBody();
      if (data.hasOwnProperty('hospital'))
        obj.hospital = HospitalsHospital.constructFromObject(data['hospital']);
    }
    return obj;
  }
}

/**
 * @member {module:model/HospitalsHospital} hospital
 */
HospitalsBody.prototype.hospital = undefined;

